module.exports = __webpack_public_path__ + "img/20200614_111501.337bc083.jpg";